import React from 'react';
import spinner from '../../assets/Spinner.svg';
import styles from './AppLoader.module.css';

const AppLoader = ({ message = 'Loading your experience...' }) => (
	<div className={styles.LoaderShell} role='status' aria-live='polite'>
		<div className={styles.LoaderCard}>
			<img src={spinner} alt='' className={styles.LoaderSpinner} />
			<span className={styles.LoaderText}>{message}</span>
		</div>
	</div>
);

export default AppLoader;
